import React, { FC } from 'react';
import settingsParams from '../../../../../settingsParams';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { useSettings } from '@wix/yoshi-flow-editor/tpa-settings/react';
import { Badge, BadgePriority as BADGE_PRIORITY } from 'wix-ui-tpa';
import Camera from 'wix-ui-icons-common/on-stage/system/VideoFillXSmall';
import { classes } from './OnlineBadge.st.css';
import { DataHooks } from './consts';

export const OnlineBadge: FC = () => {
  const settings = useSettings();
  const { t } = useTranslation();

  return (
    <Badge
      className={classes.root}
      key={DataHooks.ROOT}
      data-hook={DataHooks.ROOT}
      icon={<Camera />}
      priority={BADGE_PRIORITY.light}
    >
      {settings.get(settingsParams.onlineBadgeText) ||
        t('info-card.design.online-indication')}
    </Badge>
  );
};
